<div class="row">
  <div class="col-md-12">
    <nz-upload
      class="uploader"
      nzType="drag"
      [nzDisabled]="readOnly"
      [nzShowUploadList]="false"
      [nzMultiple]="true"
      [nzCustomRequest]="uploadFile"
      (nzChange)="handleChange($event)"
    >
      <i class="fi fi-br-gallery"></i>

      <p class="ant-upload-text" *ngIf="!message">Click, tap or drag a {{type}} to this area to upload</p>
      <p class="ant-upload-text" *ngIf="message">{{message}}</p>
      <p class="ant-upload-hint" *ngIf="type === 'photo'">
        Only images files are allowed, maximum size 4MB.
      </p>
      <p class="ant-upload-hint mb-0" *ngIf="type === 'media'">
        Any video or image format allowed up to 100MB
      </p>
      <p class="ant-upload-hint mb-0" *ngIf="type === 'video'">
        Any video format allowed up to 100MB
      </p>
    </nz-upload>

  </div>

  <div class="col-md-12">

    <div class="d-flex flex-wrap mt-10 ">
      <div class="uploaded-image-container mb-5 mb-md-0" [class.large-image]="size !== 'small'" *ngFor="let item of value; let i = index;">

        <a class="image-inner-container" *ngIf="isImage(item)" [href]="item" target="_blank" [style.background-image]="'url(' + item + ')'">

        </a>
        <a class="image-inner-container" *ngIf="!isImage(item)" [href]="item" target="_blank">
          <span class="play-icon">
            <i class="fi fi-br-play"></i>
          </span>
        </a>
        <button class="remove-button btn btn-danger w-full btn-sm" (click)="removeFile(i)">Remove</button>

      </div>
    </div>


  </div>

</div>
